import { ReactNode } from 'react';

import Tooltip from 'components/onClickTooltip';

const toolTipProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
};

interface TooltipWrapperProps {
  title: ReactNode;
  body: ReactNode;
}

const TooltipWrapper = ({ title, body }: TooltipWrapperProps) => {
  return (
    <Tooltip
      title={title}
      body={body}
      anchorOrigin={toolTipProps.anchorOrigin}
      transformOrigin={toolTipProps.transformOrigin}
      isTopLevelContainer={false}
    />
  );
};

export default TooltipWrapper;
